import React from 'react';
import { MusicRecords } from '../../pages/mypage/components/MyMusicRecords';
import usePublicRecords from './usePublicRecords';
export default function PublicMusicRecords({ profile, ...props }) {
  const records = usePublicRecords(profile);
  return (
    <MusicRecords
      {...props}
      profile={profile}
      records={records}
      basePath={`/users/${encodeURIComponent(profile.nickname)}`}
    />
  );
}
